import { Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useState } from 'react';
import { CopyBlock } from 'react-code-blocks';

import { themeCodeBlock } from '@page/explorer/components/code-example/code-example.style';
import { newSequenceFormValidation } from '@page/new-sequences/new-sequence.form-validation';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Input } from '@atom/form/input/input';
import { Form } from '@form/common.style';
import { Label } from '@form/connector-auth/connector-auth.form-style';

import { ActionWrapper, SequenceArea, SequenceWrapper } from './new-sequences.style';
import { SequenceActions } from './sequence-actions/sequence-actions';
import { SequenceConnection } from './sequence-connection/sequence-connection';

const initialValues = { name: '', serviceId: '', actions: [{}] };

export const NewSequencesPage = () => {
  const [form] = useForm();

  const [result, setResult] = useState<string>(null!);
  const [openModal, setOpen] = useState(false);

  return (
    <PageWrapper>
      <PageTitle>New Sequences</PageTitle>
      <Form form={form} initialValues={initialValues} layout='vertical' name='sequense'>
        <SequenceWrapper>
          <Label label='Name your sequence' name='name' rules={[newSequenceFormValidation]}>
            <Input placeholder='Enter your sequence name' />
          </Label>
        </SequenceWrapper>
        <SequenceArea>
          <SequenceConnection form={form} />
          <SequenceActions form={form} />
        </SequenceArea>
      </Form>
      <ActionWrapper>
        <Button type={ButtonTypeEnum.Text} disabled>
          Delete
        </Button>
        <Button
          type={ButtonTypeEnum.Primary}
          onClick={() =>
            form.validateFields().then((result) => {
              setResult(JSON.stringify(result, null, 2));
              setOpen(true);
            })
          }
        >
          Save
        </Button>
      </ActionWrapper>
      <Modal open={openModal} onCancel={() => setOpen(false)}>
        <CopyBlock language='javascript' text={result} {...themeCodeBlock} />
      </Modal>
    </PageWrapper>
  );
};
